import { useState } from "react";

// react-router-dom components

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
// Material Dashboard 2 React components
import MDAutocomplete from "components/MDAutocomplete";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
// Authentication layout components
import CallButton from 'components/CallButton';
import BasicLayoutLanding from "layouts/authentication/components/BasicLayoutLanding";
// Images
import bgImage from "assets/images/3647062.jpg";

import { Link, Typography } from '@mui/material';

const voiceNames = {
  'Hana': 'Carol',
  'Harry': 'Ryan',
  'Spencer': 'Sierra',
  'Neha': 'Priya',
  'Lily': 'Maya',
  'Savannah': 'Caroline',
  'Paige': 'Sophia',
  'Elliot': 'Alex',
  'Rohan': 'Ishaan',
  'Cole': 'Travis'
};

//Constant
const vapiVoiceOptions = {
  'vapi': [
    {
      id: "f99bf0af-e8d3-4cb9-8be0-db77c1fb90ee",
      key: "Hana",
      value: "Carol",
      description: "22 years old female, American, soft, soothing, gentle",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/hana-sample.wav"
    },
    {
      id: "3255b66d-7c7b-4344-9388-802beb60f668",
      key: "Harry",
      value: "Ryan",
      description: "24 year old white male, American, clear, energetic, professional",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/harry-sample.wav"
    },
    {
      id: "79358e5f-db73-4d89-9c87-037bf338bf69",
      key: "Spencer",
      value: "Sierra",
      description: "26 year old, female, American, energetic, quippy, lighthearted, cheeky, amused",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/spencer-sample.wav"
    },
    {
      id: "20c00a43-1f6c-4951-bc2c-26ab41bf8970",
      key: "Neha",
      value: "Priya",
      description: "30 year old, female, Indian, professional, charming",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/neha-sample.wav"
    },
    {
      id: "d4fa1f07-cbe3-4141-b150-95f1a8e0ad54",
      key: "Lily",
      value: "Maya",
      description: "25 years old female, Asian, bright personality, bubbly, cheerful",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/lily-sample.wav"
    },
    {
      id: "3d3b12fe-1641-4c96-b27a-48b85bb66dcb",
      key: "Savannah",
      value: "Caroline",
      description: "25 years old female with an American southern accent",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/savannah-sample.wav"
    },
    {
      id: "b85ab57e-3038-4728-8a4a-2d6cd02757a6",
      key: "Paige",
      value: "Sophia",
      description: "26 year old white female, deeper tone, calming, professional",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/paige-sample.wav"
    },
    {
      id: "a759321b-e350-4d51-aec0-a7e197064fb2",
      key: "Elliot",
      value: "Alex",
      description: "25 years old male, Canadian, soothing, friendly, professional",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/elliot-sample.wav"
    },
    {
      id: "baae7884-b72c-412b-abfd-80dd52f556d9",
      key: "Rohan",
      value: "Ishaan",
      description: "24 years old male, Indian American, bright, optimistic, cheerful, energetic",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/rohan-sample.wav"
    },
    {
      id: "f9ac9cff-88bc-4ac4-9f98-f04271c8e3d4",
      key: "Cole",
      value: "Travis",
      description: "22 year old white male, American, deeper tone, calming, professional",
      audioUrl: "https://files.buildwithfern.com/https://vapi.docs.buildwithfern.com/2025-05-04T01:18:39.027Z/static/audio/cole-sample.wav"
    },
  ]
};

function Demo() {
  const phoneNumber = '+1 (417) 244 1507';  // US Phone Number
  
  const [voice, setVoice] = useState("Elliot");

  const [errors, setErrors] = useState({
    emailError: false,
    passwordError: false,
  });
  
  const changeHandler = (e) => {
    setVoice(e.target.value);
  };

  return (
    <BasicLayoutLanding image={bgImage}>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            MyKey Demo
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDTypography variant="subtitle2" align="justify">
            An AI-powered demo designed for MyKey Global Accommodations, showcasing how their intake call process can be effortlessly automated to provide exceptional customer service at lower costs, available 24/7.
          </MDTypography>
          <MDTypography variant="subtitle2" align="left" mt={2}>
            AI voice agents that deliver human-like conversations, support multiple languages, and offer extensive voice customization choices.
          </MDTypography>
          <Grid container mt={4} alignItems="center" justifyContent="center">
            <Grid item xs={9} md={9}>
              <MDAutocomplete
                label="Voice Options (Just few to demonstrate)"
                name="voice_id"
                options={vapiVoiceOptions.vapi}
                value={voice}
              onChange={changeHandler}
              />
            </Grid>
            <Grid item xs={3} md={3}>
              <CallButton agent_api_id="7ed8338b-7d55-4598-9eb2-a2d13f80f1e5" voice_id={voice} first_message={`Hi! Welcome to MyKey. My name is ${voiceNames[voice]}. How can I help you today?`} />
            </Grid>
          </Grid>
          <MDTypography variant="h5" mb={2} mt={1}>
              OR
          </MDTypography>
          <Typography variant="body2">
            <Link href={`tel:${phoneNumber}`} underline="hover">
              🇺🇸 {phoneNumber}
            </Link>
          </Typography>
        </MDBox>
      </Card>
    </BasicLayoutLanding>
  );
}

export default Demo;
